import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';

import * as api from '../api/log';

const namespace = 'MOBILE';

export const FETCH_DAILY_LOG = createRequestTypes(
  `${namespace}/FETCH_DAILY_LOG`,
);

export const fetchDailyLog = makeApiActionCreatorV3(
  api.fetchDailyLog,
  FETCH_DAILY_LOG[START],
  FETCH_DAILY_LOG[SUCCESS],
  FETCH_DAILY_LOG[ERROR],
);

export const FETCH_PRODUCTIVITY = createRequestTypes(
  `${namespace}/FETCH_PRODUCTIVITY`,
);

export const fetchProductivity = makeApiActionCreatorV3(
  api.fetchProductivity,
  FETCH_PRODUCTIVITY[START],
  FETCH_PRODUCTIVITY[SUCCESS],
  FETCH_PRODUCTIVITY[ERROR],
);
